import * as types from '../mutation-types';
const state = {
	journal:{}
};

const actions = {
	fetchAll({ commit }, { start_date, end_date, keywords, debit_entries_only }) {
		return window.axios.get(`Entries`,{ 
			start_date, 
			end_date, 
			keywords, 
			debit_entries_only }).then(response => {
			commit(types.STORE_JOURNAL, response.data);
			return response.data;
		});
	},
};

const mutations = {
	[types.STORE_JOURNAL](state, journal) {
		state.journal = journal;
	},
};

const getters = {};

export default {
	namespaced: true,
	state,
	mutations,
	actions,
	getters
};

